import React, { useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv } from "../master/Master";
import Master from "./Master";
import { printElement } from "../master/Print";
import AttendanceStaffTable from "./components/AttendanceStaffTable";

export default function StaffAttendances() {
  const [loading, setLoading] = useState("");

  const [filters, setFilters] = useState({
    attendance: "",
    date: new Date().toISOString().split("T")[0],
  });

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    {/* PAGE HEADER */}
                    <div className="card mb-4">
                      <div className="card-body py-3">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                          <div>
                            <div className="d-flex align-items-center gap-2">
                              <div
                                className="rounded-3 d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
                                style={{
                                  width: 42,
                                  height: 42,
                                }}
                              >
                                <i className="ri-calendar-check-line ri-22px"></i>
                              </div>

                              <div>
                                <h4 className="mb-0 fw-bold">
                                  Staff Attendance
                                </h4>

                                <small className="text-muted">
                                  Manage daily staff attendance
                                </small>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            {/* DATE */}
                            <div
                              className="form-floating form-floating-outline"
                              style={{ minWidth: 175 }}
                            >
                              <input
                                type="date"
                                className="form-control"
                                value={filters?.date}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    date: e.target.value,
                                  })
                                }
                              />
                              <label>Attendance Date</label>
                            </div>

                            {/* PRINT */}
                            <button
                              type="button"
                              className="btn btn-outline-primary d-flex align-items-center gap-2"
                              onClick={() => printElement("PrintDiv")}
                              title="Print Attendance"
                            >
                              <i className="ri-printer-line"></i>
                              <span className="d-none d-sm-inline">Print</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ATTENDANCE TABLE */}
                    <div className="card">
                      <div className="card-body">
                        <AttendanceStaffTable
                          filters={filters}
                          setFilters={setFilters}
                          setLoading={setLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
